import { CommonModule, CurrencyPipe, registerLocaleData } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import localeDe from "@angular/common/locales/de";
import localeDeExtra from "@angular/common/locales/extra/de";
import { ErrorHandler, LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CookieModule } from "ngx-cookie";
import { RateBaugeraeteService } from "../rate/rate-baugeraete.service";
import { AppComponent } from "./app.component";
import { AppRouting } from "./app.routing";
import { TarifrechnerCommonModule } from "@vhv/tarifrechner-common";
import { BaugeraeteZusammenfassungComponent } from "../views/antrag/baugeraete-zusammenfassung.component";
import { BaugeraeteHeaderComponent } from "../component/baugeraete-header.component";
import { StartComponent } from "../views/start/start.component";
import {BaugeraeteBeitragComponent} from "../views/beitrag/baugeraete-beitrag.component";
import { DownloadBaugeraeteService } from "../service/download-baugeraete.service";
import {BaugeraeteAnfrageDankeComponent} from "../views/antrag/baugeraete-anfrage-danke.component";
import { BaugeraeteErrorComponent } from "../views/error/baugeraete-error.component";
import { BaugeraeteDankeComponent } from "../views/antrag/baugeraete-danke.component";
import { BaugeraeteModalAreaComponent } from "../component/modal-area/baugeraete-modal-area.component";
import {PostErrorHandler} from "./post-error-handler";

registerLocaleData(localeDe, 'de', localeDeExtra);

@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        AppRouting,
        BrowserAnimationsModule,
        CookieModule.withOptions(),
        TarifrechnerCommonModule,
    ],
    declarations: [
        AppComponent,
        BaugeraeteHeaderComponent,
        BaugeraeteBeitragComponent,
        BaugeraeteZusammenfassungComponent,
        StartComponent,
        BaugeraeteAnfrageDankeComponent,
        BaugeraeteErrorComponent,
        BaugeraeteDankeComponent,
        BaugeraeteModalAreaComponent
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'de-DE' },
        RateBaugeraeteService,
        CurrencyPipe,
        DownloadBaugeraeteService,
        {provide: ErrorHandler, useClass: PostErrorHandler}
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}


